
















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Part extends Vue {
  @Prop({ required: true, type: Boolean })
  public isStickyWidth!: boolean;

  private onClickErrorLink(e: Event): void {
    e.preventDefault();
    e.stopImmediatePropagation();

    if (e && e.target instanceof HTMLAnchorElement) {
      window.open(e.target.href);
    }
  }

  private get orgErrorMessage(): string {
    const template: string = this.$store.getters['auth/currentLanguageErrorSupplementaryMessage'];
    const orgName: string = this.$store.getters['auth/currentLanguageOrgName'];

    if (!template) return '';

    // 半角・全角空白を含めた {orgName} を置換
    if (orgName && orgName !== '') {
      const orgNamedErrorMessage: string = template.replace(/\{(\s|"　"|)+orgName(\s|"　"|)+\}/g, orgName);
      return orgNamedErrorMessage;
    }

    return template;
  }
}
